export default [

     {
          path: '/RiskCalculationMatrix',
          name: 'RiskCalculationMatrix',
          component: () => import("@/views/Page/RiskCalculationMatrix/RiskCalculationMatrix.vue"),
           meta: {
               title: 'Risk Calculation Matrix',
          },
     }
];